if(window.innerWidth < 768)
{
  


  const searchBar = document.querySelector(".search-drawer .search-input input");
// if(searchBar)
// {
//   searchBar.addEventListener("click", () => {
//     setTimeout( () => {
//       // console.log("Searchbar is clicked now");
//         let autoCompleteArrows = document.querySelectorAll(".autocomplete-text-wrapper");
//         if(autoCompleteArrows){
//           // console.log("Inside if condition arrow");
//           autoCompleteArrows.forEach((arrow) => {
//             if(arrow)
//             {
//               arrow.addEventListener("click", (e) => {
//                 e.preventDefault();
//                 // console.log("click on text wrapper")
//                 searchBar.value = arrow.parentElement.getAttribute("data-searchterm");
//                 searchBar.click();
//                 // console.log(arrow.parentElement.getAttribute("data-searchterm"));
//             });
//             }
//           });
//         }
//     }, 300)
// }
// );
// }

}
let search_btn = document.querySelectorAll('.header__secondary-nav .header__icon-list a')[0];
// console.log("search button", search_btn);
if(search_btn)
{
  search_btn.addEventListener('click', function(){
    setTimeout(() => {
      let wiz_search = document.querySelector('.wizzy-search-input');
      if(wiz_search)
      {
        wiz_search.click();
      }
    }, 300);
  })
}

if(window.innerWidth < 768)
{
  let search_btn = document.querySelector('.tap-area.mobile-search');
  // console.log("search button", search_btn);
  if(search_btn)
  {
    search_btn.addEventListener('click', function(){
      setTimeout(() => {
        let wiz_search = document.querySelector('.wizzy-search-input');
        if(wiz_search)
        {
          wiz_search.click();
        }
      }, 300);
    })
  }
}
let search_bar = document.querySelector('.search-drawer');
if (search_bar) {
  search_bar.addEventListener('toggle', (e) => {
    // e.preventDefault();
    // e.stopImmediatePropagation();
    // console.log("toggle called");
    let autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
    if(autocomplete && getComputedStyle(autocomplete).display === "flex")
    {
      if (!search_bar.open) {
      // User closed it (including via Escape)
      // console.log('Details was closed. Re-opening it!');
      search_bar.removeAttribute("inert")
      }
    }
    // console.log('search-drawer toggle event', e.target.classList);
    
  });
}
//   $("body").on("click", ".search-drawer .search-input input", () => {
//   // console.log("searchbar clicked");

//    setTimeout(() => {
//     const target = document.querySelector('.wizzy-autocomplete-wrapper.onLeft');
//     const header = document.querySelector('body');
//     // console.log("Target:", target);
//     // console.log("Header:", header);

//     if (!target || !header) return;

//     const checkAndApplyClass = () => {
//       const display = getComputedStyle(target).display;
//       // console.log("Initial or updated display:", display);
//       if (display === 'flex') {
//         header.classList.add('wizzy-autocomplete-opened');
//         target.click();
//         // console.log("Class added");
//       } else {
//         header.classList.remove('wizzy-autocomplete-opened');
//         // console.log("Class removed");
//       }
//     };

//     // Check immediately after attaching
//     checkAndApplyClass();

//     const observer = new MutationObserver((mutationsList) => {
//       for (const mutation of mutationsList) {
//         if (mutation.attributeName === 'style') {
//           checkAndApplyClass();
//         }
//       }
//     });

//     observer.observe(target, {
//       attributes: true,
//       attributeFilter: ['style'],
//     });

//     // console.log("Observer attached");
//   }, 500);
  
// });
document.body.addEventListener("click", function(event) {
  if (event.target.matches(".search-drawer .search-input input")) {
    setTimeout(() => {
      const target = document.querySelector('.wizzy-autocomplete-wrapper.onLeft');
      const header = document.querySelector('body');

      if (!target || !header) return;

      const checkAndApplyClass = () => {
        const display = getComputedStyle(target).display;
        if (display === 'flex') {
          header.classList.add('wizzy-autocomplete-opened');
          target.click();
        } else {
          header.classList.remove('wizzy-autocomplete-opened');
        }
      };

      // Initial check
      checkAndApplyClass();

      // Observe style changes on target
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.attributeName === 'style') {
            checkAndApplyClass();
          }
        }
      });

      observer.observe(target, {
        attributes: true,
        attributeFilter: ['style'],
      });
    }, 500);
  }
});



const closeButton = document.querySelector('.search-drawer button[is="close-button"]');
if(closeButton)
{
  closeButton.addEventListener("click", function(e){
    e.preventDefault();
    const header = document.querySelector('body');
    const autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");
    if(autocomplete)
    autocomplete.style.setProperty("display", "none", "important");
    header.classList.remove("wizzy-autocomplete-opened");
  })
}

window.onWizzyScriptLoaded = function () {
//   function checkWizzyConfigAndUpdate() {
//   if (window.wizzyConfig.common.isOnCategoryPage == true) {
//     window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
//       "#wizzy-shopify-collection-page-wrapper",
//     ];
//   } else {
//     window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
//       "body main",
//     ];
//   }

//   clearInterval(interval); 
// }
// var interval = setInterval(checkWizzyConfigAndUpdate, 100);
  window.wizzyConfig.search.configs.pagination.type = "numbered";
   window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
  function (data) {
        data.filters.configs.layout = "v1";
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.search.configs.pagination.infiniteScrollOffset = {
            desktop: 1300,
            mobile: 1400,
        };
    return data;
  });
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
  function (data) {
    data.filters.configs.layout = "v1";
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
    // data.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];
    data.search.configs.pagination.infiniteScrollOffset = {
            desktop: 1300,
            mobile: 1400,
        };
    return data;
  });
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
  function (products) {
    products.forEach((product) => {
      product.attributes.forEach((attr) => {
        if(attr.id === "product_handle")
        {
          product.productHandle = attr .values[0].value[0];
        }
        if(attr.id === "product_badge_judgeme")
        {
          let htmlString = attr.values[0].value[0];
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, 'text/html');
          // console.log("DOC", doc);
          const div = doc.querySelector('.jdgm-prev-badge');
          const reviewCount = parseInt(div.getAttribute('data-number-of-reviews'), 10);
          // console.log(reviewCount);
          // console.log(typeof reviewCount);
          product.reviewCount = reviewCount;
        }
        if(attr.id === "product_product_card_subtitle_custom")
        {
          product.subtitle = attr.values[0].value[0];
        }
      })
      if (product.groupId === "" || product.groupId === null) {
            product.attributes.forEach((attr) => {
                if (attr.id === "product_variant_ids") {
                    if (typeof product.singleVarientGroupId === "undefined") {
                        product.singleVarientGroupId = product.id
                        product.id = attr.values[0].value[0];
                    }
                }
            })
      }
      
    });
    return products;
  });
  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
      function (data) {
        
        const sortCloseDiv = document.querySelector(
          ".wizzy-common-select-container .wizzy-common-select-options.title-mobile"
        );
        if (sortCloseDiv) {
          sortCloseDiv.style.display = "none";
        }

        if(window.wizzyConfig?.common?.isOnCategoryPage)
        {
          const alreadyExists1 = data.filters.sort.some(
            (s) => s.field === "product_wizzy-best-selling_sortOrder:float" && s.order === "asc"
          );
          if (!alreadyExists1 && data.filters.sort[0].field === "relevance") {
            data.filters.sort.push({ field: "product_wizzy-best-selling_sortOrder:float", order: "asc" });
          }
          // data.filters.sort.push({
          //   field: "product_wizzy-best-selling_sortOrder:float",
          //   order: "asc"
          // });
        }
        
        return data;
      }
  );
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
  function (data) {
    // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];
    document.body.classList.remove('wizzy-collection');
    document.body.classList.add('wizzy-search');
    let closeButton = document.querySelector('search-drawer form .search-input button[is="close-button"]');
    if(closeButton)
    {
      closeButton.click();
    }
    if (data?.sort?.length) {
      data.sort.push(
        { field: "product_wizzy-best-selling_sortOrder:float", order: "asc" }
      );
    }
    return data;
  }, 3);
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
  function (data) {
    if(window.wizzyConfig.common.isOnCategoryPage)
    {
      document.body.classList.add('wizzy-collection');
    }
    // console.log("view render called");
     const firstFilterBlock = document.querySelector(".wizzy-search-filters-left-wrapper .wizzy-facet-list-block .wizzy-filters-facet-block");
        firstFilterBlock && firstFilterBlock.classList.contains("first-opened") && firstFilterBlock.classList.remove("collapsed");
    let selected_filters = document.querySelector('.wizzy-selected-filters .wizzy-filters-selected-facets-block .wizzy-selected-facet-list');
    if (selected_filters) {
      const count = selected_filters.children.length;
      if (count !== 0) {
        let apply_button = document.querySelector('.wizzy-search-filters-left .facets-drawer__floating-apply button');
        if (apply_button) {
          apply_button.textContent = "Apply " + count;
        }
      }
    }
    $('.add_to_cart_form_cu').on('submit', function(event){

            // var rawDOMElement = $(this).get(0);
            // var eventObject = $._data(rawDOMElement, 'events');
            // if(eventObject != undefined && eventObject.submit != undefined) {
            //     return false;
            // }

            // get data
            var $atc_btn = $(this).find(".add-to-cart-button");
            var $t = $(".header__cart-count").find(".count-bubble");
            //var $t_in = $(".cart-drawer__top").find(".count-bubble");
        
        
            // disable atc button and cart count
            $atc_btn.prop("disabled", true);
            $t.css("opacity", "0");
            //$t_in.css("opacity", "0");
        
            event.preventDefault(); // prevent default form submission
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: $(this).serialize(),
                dataType: 'json',
                success: function() {
        
                    var item_count;
                    $.when( 
                        jQuery.getJSON('/cart.js', function(cart) {
                            item_count = cart.item_count;
                            let cartData = cart.items;
                            document.dispatchEvent(new CustomEvent('cart:build' ,{
                                    bubbles: true
                                }
                            )); 
                            document.dispatchEvent(new CustomEvent('cart:refresh', {
                                bubbles: true,
                                detail: cartData
                            })); 
        
                            // get cart drawer 
                            document.dispatchEvent(new CustomEvent('variant:add', {
                                bubbles: true,
                            }));
                        })
                    ).then(function(){
                        
                        setTimeout(function(){
                            
                            // update cart count + enable opacity + enable atc btn
                            $t.html(item_count);
                            $t.css("opacity", "1");
                            //$t_in.css("opacity", "1");
                            $atc_btn.prop("disabled", false);
        
                        }, 2000);
        
                    });
                },
                error: function(e) {
                    // for further debugging
                    // console.log(e.responseJSON);
                    
                    // restore button and count
                    $t.css("opacity", "1");
                    //$t_in.css("opacity", "1");
                    $atc_btn.prop("disabled", false);
                }
            });
        
        }); 
    
    let close_sort = document.querySelector('.sortby-close');
    if(close_sort)
    {
      close_sort.addEventListener("click", function(){
        let sort_btn = document.querySelector('.wizzy-common-select-selector');
        if(sort_btn)
        {
          sort_btn.click();
        }
      })
    }

    let apply_button = document.querySelector('.wizzy-search-results-rendered .facets-drawer__floating-apply');
    if(apply_button)
    {
      apply_button.addEventListener('click', function(){
        let close_button = document.querySelector('.wizzy-filters-close-btn');
        if(close_button)
        {
          close_button.click();
        }
      })
    }

    gridFiltersToggleOnOverflow();
    

    return data;
  });
  
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
  function (data) {
    if(window.wizzyConfig.common.isOnCategoryPage)
    {
      document.body.classList.add('wizzy-collection');
    }
    document.body.classList.add('wizzy-search-results-rendered');
    $('.add_to_cart_form_cu').on('submit', function(event){

            // var rawDOMElement = $(this).get(0);
            // var eventObject = $._data(rawDOMElement, 'events');
            // if(eventObject != undefined && eventObject.submit != undefined) {
            //     return false;
            // }

            // get data
            var $atc_btn = $(this).find(".add-to-cart-button");
            var $t = $(".header__cart-count").find(".count-bubble");
            //var $t_in = $(".cart-drawer__top").find(".count-bubble");
        
        
            // disable atc button and cart count
            $atc_btn.prop("disabled", true);
            $t.css("opacity", "0");
            //$t_in.css("opacity", "0");
        
            event.preventDefault(); // prevent default form submission
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: $(this).serialize(),
                dataType: 'json',
                success: function() {
        
                    var item_count;
                    $.when( 
                        jQuery.getJSON('/cart.js', function(cart) {
                            item_count = cart.item_count;
                            let cartData = cart.items;
                            document.dispatchEvent(new CustomEvent('cart:build' ,{
                                    bubbles: true
                                }
                            )); 
                            document.dispatchEvent(new CustomEvent('cart:refresh', {
                                bubbles: true,
                                detail: cartData
                            })); 
        
                            // get cart drawer 
                            document.dispatchEvent(new CustomEvent('variant:add', {
                                bubbles: true,
                            }));
                        })
                    ).then(function(){
                        
                        setTimeout(function(){
                            
                            // update cart count + enable opacity + enable atc btn
                            $t.html(item_count);
                            $t.css("opacity", "1");
                            //$t_in.css("opacity", "1");
                            $atc_btn.prop("disabled", false);
        
                        }, 1000);
        
                    });
                },
                error: function(e) {
                    // for further debugging
                    // console.log(e.responseJSON);
                    
                    // restore button and count
                    $t.css("opacity", "1");
                    //$t_in.css("opacity", "1");
                    $atc_btn.prop("disabled", false);
                }
            });
        
        }); 
    
    let close_sort = document.querySelector('.sortby-close');
    if(close_sort)
    {
      close_sort.addEventListener("click", function(){
        let sort_btn = document.querySelector('.wizzy-common-select-selector');
        if(sort_btn)
        {
          sort_btn.click();
        }
      })
    }

    let apply_button = document.querySelector('.wizzy-search-results-rendered .facets-drawer__floating-apply');
    if(apply_button)
    {
      apply_button.addEventListener('click', function(){
        let close_button = document.querySelector('.wizzy-filters-close-btn');
        if(close_button)
        {
          close_button.click();
        }
      })
    }

    gridFiltersToggleOnOverflow();
    

    return data;
  });
};


function gridFiltersToggleOnOverflow() {
  if (window.innerWidth > 768) {
    const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");

    if (filterBoxes.length > 0) {
      filterBoxes.forEach((box) => {
        const filterList = box.querySelector(
          ".wizzy-facet-body .wizzy-facet-list"
        );
        const toggleBtn = box.querySelector(
          ".wizzy-facet-body .wizzy-toggle-btn"
        );
        const filterOptions = box.querySelector(".wizzy-facet-body");

        if (
          filterList &&
          toggleBtn &&
          filterOptions &&
          !toggleBtn.classList.contains("wizzy-click-event-attached")
        ) {
          const filterHeight = filterList.offsetHeight;
          const lineHeight = parseFloat(
            getComputedStyle(filterList).lineHeight
          );
          const maxVisibleLines = 2;
          const visibleLines = Math.floor(filterHeight / lineHeight) - 1;
          if (visibleLines > maxVisibleLines) {
            filterOptions.classList.add("collapsed");
            toggleBtn.classList.add("wizzy-click-event-attached");
            toggleBtn.style.display = "inline-block";
          } else {
            toggleBtn.style.display = "none";
          }

          toggleBtn.addEventListener("click", function () {
            if (filterOptions.classList.contains("collapsed")) {
              filterOptions.classList.remove("collapsed");
              filterOptions.classList.add("expanded");
              toggleBtn.innerText = "- Less";
            } else {
              filterOptions.classList.remove("expanded");
              filterOptions.classList.add("collapsed");
              toggleBtn.innerText = "+ More";
            }
            toggleBtn.classList.add("wizzy-click-event-attached");
          });
        }
      });
    }
  }
}

if (window.innerWidth < 768) {
  const searchBar = document.querySelector(
    ".search-input .wizzy-search-input"
  );
  if (searchBar) {
    searchBar.addEventListener("click", () => {
      setTimeout(() => {
        let autoCompleteArrows = document.querySelectorAll(
          ".autocomplete-text-wrapper"
        );
        if (autoCompleteArrows) {
          autoCompleteArrows.forEach((arrow) => {
            if (arrow) {
              arrow.addEventListener("click", () => {
                arrow.click();
                arrow.click();
                searchBar.blur();
                // console.log("clicked on arrow");
                searchBar.value =
                  arrow.parentElement.getAttribute("data-searchterm");
                searchBar.focus();
                // console.log(arrow.parentElement.getAttribute("data-searchterm"));
              });
            }
          });
        }
      }, 500);
  
      // let modalOverlay = document.querySelector(".modal-overlay");
      // modalOverlay.forEach((modal)=>{
      //   modal.addEventListener("click",()=>{
      //     let searchCloseButton =
      //   })
      // })
    });
  }
}